import * as React from 'react';

import Map, {Layer, Marker, Popup, Source} from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

// eslint-disable-next-line
import mapboxgl from '!mapbox-gl';
import {Box, CircularProgress, Typography} from "@mui/material";
import * as turf from "@turf/turf";
import {correctName, formatPercentage, getLabelFromNuance} from "../../../Utils";
import {useCallback, useState} from "react";

// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;
const MAPBOX_TOKEN = 'pk.eyJ1IjoiYmxhbmdlNDgiLCJhIjoiY2xkMWhrcjBzMDB1aDNzbGVsdGR5cGU1aSJ9.xcs1ihAFqlazzqNrXNiobQ';


export default function MapEpci({geomEpci, resultsOfEpcis, year, codeInsee, visible, mappingBvArrondissement}) {


    const [centroid, setCentroid] = React.useState(null);
    const [bbox, setBBbox] = React.useState(null);

    const [loading, setLoading] = React.useState(true);
    const [colorMap, setColorMap] = React.useState(null);

    const [popupInfo, setPopupInfo] = React.useState(null);

    React.useEffect(() => {
        if (geomEpci) {
            let bbox = turf.bbox(geomEpci);
            let centroid = turf.centroid(geomEpci);
            setCentroid(centroid.geometry.coordinates);
            setBBbox([[bbox[0] - 0.001, bbox[1] - 0.001], [bbox[2] + 0.001, bbox[3] + 0.001]]);

            let colorMap = {}

            geomEpci.features.forEach((epci) => {
                const shp = epci;
                let codeGeo = shp.properties.codgeo.replace("'", "");
                let r = resultsOfEpcis[codeGeo];

                let c = null;
                if (r == null || !r["winner"]) {
                    c = getLabelFromNuance("LDIV", year)
                } else {

                    c = getLabelFromNuance(r["winner"].nuance, year);
                }
                colorMap[c.name] = c;
            })
            setColorMap(colorMap);
        }
    }, [geomEpci, resultsOfEpcis]);

    React.useEffect(() => {
        if (centroid && bbox && geomEpci && resultsOfEpcis && colorMap) {
            setLoading(false);
        }
    }, [centroid, bbox, geomEpci, resultsOfEpcis, colorMap])


    const [hoverInfo, setHoverInfo] = useState(null);
    const selectedCounty = (hoverInfo && hoverInfo.irisName) || '';


    const onHover = useCallback(event => {
        let found = geomEpci.features.filter((element) => {

            return turf.booleanPointInPolygon([event.lngLat.lng, event.lngLat.lat], element.geometry);
        });
        if (found.length > 0) {
            let centroid = turf.centroid(found[0].geometry);
            let bvInfo = resultsOfEpcis[found[0].properties.codgeo];
            if (bvInfo == null) {
                bvInfo = {
                    nuance: "LDIV",
                    nomPrenom: "Aucun candidat"
                }
            }
            setPopupInfo({
                    longitude: centroid.geometry.coordinates[0],
                    latitude: centroid.geometry.coordinates[1],
                    bvInfo: bvInfo,
                    codeInsee: found[0].properties.codgeo,
                    properties: found[0].properties
                }
            );

        } else {

            setPopupInfo(null)
        }
    }, []);

    if (visible) {
        if (loading) {
            return (<Box sx={{
                width: '100%',
                height: 610,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
                <CircularProgress/>
            </Box>)
        } else {
            return (<Box sx={{width: '100%', height: 610, display: 'flex', flexDirection: 'row'}}>
                <Map
                    style={{
                        width: "80%",
                        height: 600,
                        borderRadius: 25
                    }}
                    initialViewState={{
                        longitude: centroid[0],
                        latitude: centroid[1],
                        bounds: bbox

                    }}
                    mapStyle="mapbox://styles/mapbox/streets-v9"
                    mapboxAccessToken={MAPBOX_TOKEN}
                    interactive={true}
                    preserveDrawingBuffer={true}
                    attributionControl={false}
                    onMouseMove={onHover}

                >
                    {geomEpci.features.map((geom, key) => {
                        const shp = geom;
                        if (shp.properties.codgeo !== codeInsee) {
                            let r = resultsOfEpcis[shp.properties.codgeo];
                            let color = "#ffffff";
                            let colorLine = "#ffffff";
                            if (r && r["winner"]) {
                                color = getLabelFromNuance(r["winner"].nuance, year).color
                            }
                            if (shp.properties.codgeo === codeInsee) {
                                colorLine = "#000"
                            }
                            return (<Source
                                key={key}
                                type="geojson"
                                data={shp}
                            >
                                <Layer

                                    type={'fill'}
                                    paint={{

                                        'fill-color': color,
                                        'fill-opacity': 0.5,

                                    }}
                                />
                            </Source>)
                        }

                    })}
                    {geomEpci.features.map((geom, key) => {
                        const shp = geom;

                        let r = resultsOfEpcis[shp.properties.codgeo];
                        let color = "#ffffff";
                        if (r && r["winner"]) {

                            color = getLabelFromNuance(r["winner"].nuance, year).color
                        }
                        return [<Source
                            key={key}
                            type="geojson"
                            data={shp}>
                            <Layer
                                type={'fill'}
                                paint={{

                                    'fill-color': color,
                                    'fill-opacity': 0.5,

                                }}
                            />
                        </Source>,
                            <Source
                                key={key + "-line"}
                                type="geojson"
                                data={shp}>
                                <Layer
                                    type={'line'}
                                    paint={{
                                        'line-color': "#000"
                                    }}
                                />
                            </Source>]

                    })}
                    {popupInfo && (
                        <Popup
                            anchor="left"
                            longitude={popupInfo.longitude}
                            latitude={popupInfo.latitude}
                            closeButton={false}
                        >
                            <Box sx={{display: "flex", flexDirection: "column", p: 2, gap: 1, width: "max-content"}}>
                                <Typography sx={{
                                    fontSize: "18px",

                                    fontStyle: "normal",
                                    fontWeight: 700,

                                }}>{popupInfo.properties.libgeo}</Typography>
                                <Typography variant={"body1"}>Abstentions
                                    : {formatPercentage(popupInfo.bvInfo.abstentions / popupInfo.bvInfo.inscrits)}</Typography>
                                <Typography variant={"body1"} sx={{
                                    width: "100%",
                                    fontStyle: "normal",
                                    fontWeight: 700,
                                }}>{correctName(popupInfo.bvInfo["winner"].nomPrenom)}&nbsp;
                                    ({formatPercentage(popupInfo.bvInfo["winner"].nb / popupInfo.bvInfo.exprime)})</Typography>
                                <Box sx={{
                                    display: "flex", flexDirection: "row", gap: 2,
                                }}>
                                    <Typography variant={"body2"} sx={{
                                        width: 20,
                                        height: 20,
                                        borderRadius: 25,
                                        backgroundColor: getLabelFromNuance(popupInfo.bvInfo["winner"].nuance).color,
                                        mr: 1
                                    }}>

                                    </Typography>
                                    <Typography variant={"body2"}>
                                        {getLabelFromNuance(popupInfo.bvInfo["winner"].nuance).name}
                                    </Typography>
                                </Box>
                            </Box>
                        </Popup>
                    )}
                </Map>
                <Box sx={{
                    width: '20%',
                    ml: 2
                }}>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            padding: "5px 10px",
                            alignItems: "center",
                            gap: "20px",
                            borderRadius: "10px",
                            p: 2,
                            background: "#F7F7F7"
                        }}>
                        <Typography sx={{
                            color: "#000",
                            fontSize: "16px",
                            fontStyle: "normal",
                            fontWeight: 700,
                            lineHeight: "24px"
                        }}>Légendes</Typography>
                        {Object.keys(colorMap).sort((a, b) => {
                            return a < b
                        }).map((color, key) => {
                            return (<Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    width: "100%"
                                }}
                                key={key}>
                                <Box sx={{
                                    width: 25,
                                    height: 25,
                                    backgroundColor: colorMap[color].color,
                                    borderRadius: 25
                                }}></Box>
                                <Typography sx={{
                                    ml: 1,
                                    color: "#666",
                                    fontSize: "16px",
                                    fontStyle: "normal",
                                    fontWeight: 400,
                                    lineHeight: "24px"
                                }}>{colorMap[color].name}
                                </Typography>
                            </Box>)
                        })}
                    </Box>
                </Box>
            </Box>);
        }
    }
}
